import { todayUpdates } from "@/mocks/comics";

export default function TodayUpdates() {
  return (
    <section id="today" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium">
              <i className="ri-sun-line" />
              DAILY UPDATE
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">今日最新更新</h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">同步全网最新话，热门连载更新快人一步</p>
          </div>
          <a
            href="#today"
            className="inline-flex items-center whitespace-nowrap rounded-full border border-background-300 text-foreground-700 hover:text-primary-600 hover:border-primary-300 text-sm font-medium px-4 py-2 transition-colors cursor-pointer"
          >
            查看全部更新
            <i className="ri-arrow-right-line ml-1.5" />
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {todayUpdates.map((comic) => (
            <article
              key={comic.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200 transition-transform duration-300 hover:-translate-y-1"
            >
              <a href="#today" className="block cursor-pointer">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}最新话封面`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  {comic.hot && (
                    <span className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1">
                      <i className="ri-fire-fill" />
                      热门
                    </span>
                  )}
                  <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/70 text-background-50 text-xs px-2 py-1 backdrop-blur">
                    {comic.latestChapter}
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base truncate">{comic.title}</h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 truncate">{comic.author}</p>
                  <div className="mt-2.5 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 text-primary-600 text-xs md:text-sm font-medium">
                      <i className="ri-refresh-line" />
                      新章节
                    </span>
                    <span className="text-xs text-foreground-500">{comic.updateTime}</span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}